import React, { Component, Fragment } from "react";
import CartMenu from "../containers/CartMenu";
import MyAccount from "../containers/MyAccount";
import SearchBar from "./SearchBar";

class ToolBar extends Component {
  constructor(props) {
    super(props);
    this.state = { isSearchFormVisible: false };
    this.onSearchClickHandler = this.onSearchClickHandler.bind(this);
  }

  onSearchClickHandler(openSearchForm) {
    this.setState({ isSearchFormVisible: openSearchForm });
  }

  render() {
    const isCatalogueMode =
      this.props.settings && this.props.settings.isCatalogueMode === true;
    return (
      <Fragment>
        <SearchBar
          settings={this.props.settings}
          isSearchFormVisible={this.state.isSearchFormVisible}
          onCloseClick={this.onSearchClickHandler}
        />
        <div className="toolbar">
          <div className="inner">
            <div className="tools">
              <div
                className="search mr-2"
                onClick={() => this.onSearchClickHandler(true)}
              >
                <i className="icon-search"></i>
              </div>
              {isCatalogueMode === false && <MyAccount />}
              {isCatalogueMode === false && <CartMenu />}
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default ToolBar;
